/* @jsx h */
import { Fragment } from 'preact';

const Picture = ({ picture, alt, title, copyright }) => {
  return (
    <Fragment>
      <picture>
        {Array.isArray(picture) ? (
          picture.map(pic => {
            if (pic.tag === 'img') {
              return (
                <img
                  key={pic.src || pic.srcset}
                  src={pic.src}
                  alt={alt}
                  title={title}
                  data-click-redirect
                />
              );
            } else {
              return (
                <source
                  key={pic.src || pic.srcset}
                  srcSet={pic.srcset}
                  media={pic.media}
                  type={pic.type}
                />
              );
            }
          })
        ) : (
          <img key={picture} src={picture} alt={title} />
        )}
      </picture>
      {copyright ? (
        <figcaption className="figcaption figcaption--hover">
          <p>© {copyright}</p>
        </figcaption>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default Picture;
